import { portalNav, portalRoutes } from '@ircf/config';
import { useSession } from '../app/session.js';
import { AppShell, useUnreadCounts } from './AppShell.js';

/**
 * Client portal shell. Mobile-first: clients open this on a phone between sets,
 * so navigation collapses and content is single-column below `lg`.
 */
export function PortalLayout() {
  const { requiresApproval } = useSession();
  const { data } = useUnreadCounts();

  return (
    <AppShell
      variant="client"
      locked={requiresApproval}
      nav={requiresApproval ? [] : portalNav}
      areaLabel="Client Portal"
      notificationsPath={portalRoutes.notifications.path}
      settingsPath={portalRoutes.settings.path}
      badges={{
        messages: data?.messages ?? 0,
        notifications: data?.notifications ?? 0,
        'check-ins': data?.checkInsDue ?? 0,
      }}
    />
  );
}
